import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import ApiVersionConstants from "src/app/constants/api-version-constants";
import { ShippingAccount } from "src/app/models/ShippingAccount";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ShippingAccountsService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/shippingAccounts`;

  constructor(private http: HttpClient) {}

  public getAllAsync(): Promise<ShippingAccount[]> {
    return lastValueFrom(this.http.get<ShippingAccount[]>(`${this.baseUrl}`));
  }
}
